import { extractErrorMessage } from './errorHelper';

export const AUTH_CONTEXT_QUERY_KEYS = ['redirect', 'brandId'];

export function getAuthContextFromSearch(search) {
  const params =
    typeof search === 'string'
      ? new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
      : search;
  const context = {};

  AUTH_CONTEXT_QUERY_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      context[key] = value;
    }
  });

  return context;
}

export function buildAuthSearchString(context = {}) {
  const params = new URLSearchParams();

  AUTH_CONTEXT_QUERY_KEYS.forEach((key) => {
    if (context[key]) {
      params.set(key, context[key]);
    }
  });

  const query = params.toString();
  return query ? `?${query}` : '';
}

export function buildAuthPath(pathname, context = {}) {
  return `${pathname}${buildAuthSearchString(context)}`;
}

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

export function getRequestErrorMessage(err, fallback) {
  return extractErrorMessage(err, fallback);
}

export function evaluatePasswordRules(password) {
  const lengthOk = password.length >= 8 && password.length <= 20;
  const letterNumberOk = /[A-Za-z]/.test(password) && /\d/.test(password);
  const noSpacesOk = password.length > 0 && !/\s/.test(password);
  const noSpecialOk = password.length > 0 && /^[A-Za-z0-9]+$/.test(password);
  return { lengthOk, letterNumberOk, noSpacesOk, noSpecialOk };
}